import { render } from "./NewBaggingModal.vue?vue&type=template&id=53d29b00&scoped=true"
import script from "./NewBaggingModal.vue?vue&type=script&lang=js"
export * from "./NewBaggingModal.vue?vue&type=script&lang=js"

import "./NewBaggingModal.vue?vue&type=style&index=0&id=53d29b00&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d29b00"]])

export default __exports__